import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDeleteScenarioGrant = () => {
  const { mutate: deleteScenarioGrant, isPending } = useAppMutation(
    [QueryKey.DELETE_SCENARIO_GRANT],
    {
      mutationFn: ({ scenarioId, grantId }: { grantId: string; scenarioId: string }) =>
        ApiService.delete({
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'grants', grantId],
        }),
    },
  );
  return { deleteScenarioGrant, isPending };
};
